import { styled } from "@mui/material/styles";
import { PenLoader } from "@UI";
import React from "react";
import { useTranslation } from "react-i18next";
const Wrap = styled("div")({
    display: "flex",
    alignItems: "center",
    padding: "var(--j-sp-0-5)",
    color: "var(--j-ink-2)"
});
export function WaitingIndicator() {
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Wrap, {
        role: "status",
        "aria-label": t("chat.working")
    }, /*#__PURE__*/ React.createElement(PenLoader, {
        state: "thinking",
        size: 20,
        "aria-hidden": true
    }));
}
